import { createApp } from 'vue'
import App from './App.vue'
import './plugins/element.js'
import installElementPlus from './plugins/element'
import router from './router'
import 'xe-utils'
import vxeTable from 'vxe-table'
import 'vxe-table/lib/style.css'
import zhTW from 'vxe-table/lib/locale/lang/zh-TW'
import XEUtils from 'xe-utils'

const app = createApp(App).use(router)

vxeTable.setup({
i18n: (key, args) => XEUtils.toFormatString(XEUtils.get(zhTW, key), args)
})
app.use(vxeTable)
installElementPlus(app)
app.mount('#app')